import { Button, ButtonGroup, Field, Link, TextOutput } from 'Components/Core';
import { FieldSet, ListFieldSection, PageSection } from 'Components/Layout';
import { actions } from 'Data/ReduxViewModels/Admin';
import { Guid } from 'Lib/Guid';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { IReportConfigurationGroupList } from './types';

const ReportConfigurationGroupListAdmin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data: IReportConfigurationGroupList = useSelector((state: any) => {
    return state.admin.syncModel;
  });

  const createNewConfigurationGroup = () =>
    dispatch(
      actions.createReportConfigurationGroup({
        newReportConfiguration: { Name: '', Content: '' },
      })
    );

  const idForNewItem: string | null = useSelector((state) => state.admin.reportConfigurationGroup.create.id);

  const removeConfig = (id: Guid) => {
    dispatch(actions.deleteReportConfigurationGroup({ id: id }));
  };

  useEffect(() => {
    if (idForNewItem) {
      dispatch(actions.clearReportConfigurationGroupCreateId()); //clear id before navigate
      navigate(`/admin/report-configuration-group/${idForNewItem}`);
    }
  }, [navigate, dispatch, idForNewItem]);

  return (
    <>
      <PageSection heading="Groups">
        {data.Items &&
          data.Items.map((group) => {
            return (
              <ListFieldSection>
                <Field input={<TextOutput />} value={group.Name} />
                <FieldSet>
                  <Field
                    input={<Link />}
                    to={`/admin/report-configuration-group/${group.Id}`}
                    content={`${group.SystemDefined ? 'View' : 'Edit'} Configuration`}
                  />
                  {!group.SystemDefined && (
                    <Field
                      input={<Link />}
                      to="#"
                      content="Delete Group"
                      confirm
                      confirmText="Are you sure you want to delete this group?"
                      confirmButtonText="Delete Group"
                      confirmTitle="Delete Report Configuration Group"
                      onClick={() => removeConfig(group.Id)}
                    />
                  )}
                </FieldSet>
              </ListFieldSection>
            );
          })}
      </PageSection>
      <PageSection heading="Create New Group">
        <FieldSet>
          <ButtonGroup>
            <Button onClick={() => createNewConfigurationGroup()}>Create New Configuration Group</Button>
          </ButtonGroup>
        </FieldSet>
      </PageSection>
    </>
  );
};

export default ReportConfigurationGroupListAdmin;
export { ReportConfigurationGroupListAdmin };
